import { apiClient } from './client'

export interface SurveyAssignment {
  id: string
  member_id: string
  survey_id: string
  organization_id: string
  assigned_at: string
  assigned_by: string
  status: 'PENDING' | 'COMPLETED' | 'OVERDUE' | 'WAIVED'
  last_completed_at?: string
  current_due_date?: string
  next_due_date?: string
  reminders_sent: number
  member_email?: string
  member_name?: string
  survey_title?: string
  days_overdue?: number
}

export interface MyAssignment {
  id: string
  survey_id: string
  survey_title: string
  survey_public_id?: string
  survey_status: string
  organization_id: string
  organization_name: string
  assigned_at: string
  status: 'PENDING' | 'COMPLETED' | 'OVERDUE' | 'WAIVED'
  last_completed_at?: string
}

class AssignmentsAPI {
  async assignMembers(orgId: string, surveyId: string, memberIds: string[]): Promise<{
    message: string
    assigned_count: number
    skipped_count: number
    assignments: SurveyAssignment[]
  }> {
    const response = await apiClient.post(
      `/organizations/${orgId}/surveys/${surveyId}/assign`,
      { member_ids: memberIds },
    )
    return response.data
  }

  async unassignMember(orgId: string, surveyId: string, memberId: string): Promise<void> {
    await apiClient.delete(
      `/organizations/${orgId}/surveys/${surveyId}/assign/${memberId}`,
    )
  }

  async getAssignments(orgId: string, surveyId: string): Promise<SurveyAssignment[]> {
    const response = await apiClient.get(
      `/organizations/${orgId}/surveys/${surveyId}/assignments`,
    )
    return response.data
  }

  async getMyAssignments(): Promise<MyAssignment[]> {
    const response = await apiClient.get('/me/assignments')
    return response.data
  }

  async getOverdue(orgId: string): Promise<SurveyAssignment[]> {
    const response = await apiClient.get(`/organizations/${orgId}/overdue`)
    return response.data
  }

  async extendDueDate(orgId: string, surveyId: string, memberId: string, days: number): Promise<void> {
    await apiClient.post(`/organizations/${orgId}/surveys/${surveyId}/assign/${memberId}/extend`, { days })
  }

  async waiveAssignment(orgId: string, surveyId: string, memberId: string): Promise<void> {
    await apiClient.post(`/organizations/${orgId}/surveys/${surveyId}/assign/${memberId}/waive`)
  }

  async sendReminder(orgId: string, surveyId: string, memberId: string): Promise<void> {
    await apiClient.post(`/organizations/${orgId}/surveys/${surveyId}/assign/${memberId}/remind`)
  }
}

export const assignmentsAPI = new AssignmentsAPI()
